export default __webpack_public_path__ + "static/media/route.37993341.png";